export default "__VITE_ASSET__TBS_n8zJ__"